class PpTrialKitPopup extends HTMLElement {
  connectedCallback() {
    // Prevent the same custom element from being initialized twice
    if (this.initialized) return;
    this.initialized = true;

    this.sectionId = this.dataset.sectionId;
    this.root = document.getElementById(`pp-trial-kit-popup-${this.sectionId}`);

    if (!this.root) return;

    // Unique storage key for this specific popup section
    this.storageKey = `pp_trial_kit_popup_dismissed_until_${this.sectionId}`;

    this.frequencyDays = Number(this.root.dataset.ppFrequencyDays) || 7;
    this.delaySeconds = Number(this.root.dataset.ppDelay) || 6;

    this.closeButtons = this.root.querySelectorAll('[data-pp-close]');

    this.closeButtons.forEach((el) => {
      el.addEventListener('click', () => this.close());
    });

    this.root
      .querySelector('[data-pp-login-cta]')
      ?.addEventListener('click', () => {
        this.track('pp_login_cta_click');
      });

    this.handleKeydown = (event) => {
      if (event.key === 'Escape' && !this.root.hidden) {
        this.close();
      }
    };

    document.addEventListener('keydown', this.handleKeydown);

    if (this.shouldShow()) {
      this.showTimer = window.setTimeout(() => {
        this.open();
      }, this.delaySeconds * 1000);
    }
  }

  disconnectedCallback() {
    if (this.showTimer) {
      clearTimeout(this.showTimer);
    }

    if (this.handleKeydown) {
      document.removeEventListener('keydown', this.handleKeydown);
    }
  }

  shouldShow() {
    try {
      const until = Number(localStorage.getItem(this.storageKey) || 0);
      return !until || Date.now() >= until;
    } catch (error) {
      // If browser storage is blocked, still allow popup to show
      return true;
    }
  }

  open() {
    if (!this.root || !this.shouldShow()) return;

    this.root.hidden = false;

    requestAnimationFrame(() => {
      this.root.classList.add('is-visible');
    });

    this.track('pp_popup_shown');
  }

  close() {
    if (!this.root || this.root.hidden) return;

    this.root.classList.remove('is-visible');

    window.setTimeout(() => {
      if (this.root) {
        this.root.hidden = true;
      }
    }, 200);

    try {
      const until =
        Date.now() +
        this.frequencyDays * 24 * 60 * 60 * 1000;

      localStorage.setItem(this.storageKey, String(until));
    } catch (error) {
      // Ignore storage errors
    }

    this.track('pp_popup_dismissed');
  }

  track(eventName) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: eventName,
      section_id: this.sectionId
    });
  }
}

if (!customElements.get('pp-trial-kit-popup')) {
  customElements.define('pp-trial-kit-popup', PpTrialKitPopup);
}